import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Loader2, Lock, X } from "lucide-react";
import { useContent } from "@/content/ContentContext";

export const CheckoutModal = ({ open, onOpenChange }) => {
    const content = useContent();
    const checkoutUrl =
        content.settings?.checkout_url || process.env.REACT_APP_CHECKOUT_URL;
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (open) setLoaded(false);
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="checkout-modal"
                className="flex h-[92vh] max-w-[96vw] flex-col gap-0 overflow-hidden rounded-2xl border-0 bg-white p-0 lg:max-w-6xl [&>button]:hidden"
            >
                <DialogTitle className="sr-only">
                    AdvantaShield secure checkout
                </DialogTitle>

                <div className="flex h-14 shrink-0 items-center justify-between bg-[#0A0D14] px-5">
                    <div className="flex items-center gap-2.5">
                        <Lock className="h-4 w-4 text-sky-400" />
                        <p className="font-display text-sm font-semibold text-white">
                            AdvantaShield{" "}
                            <span className="text-slate-400">Secure Checkout</span>
                        </p>
                    </div>
                    <button
                        data-testid="checkout-close-btn"
                        onClick={() => onOpenChange(false)}
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-[background-color,color] duration-200 hover:bg-white/10 hover:text-white"
                        aria-label="Close checkout"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>

                <div className="relative flex-1 bg-white">
                    {!loaded && (
                        <div
                            data-testid="checkout-loader"
                            className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-white"
                        >
                            <Loader2 className="h-8 w-8 animate-spin text-sky-500" />
                            <p className="text-sm font-medium text-slate-500">
                                Connecting to the secure quote portal…
                            </p>
                            <p className="max-w-xs text-center text-xs text-slate-400">
                                First load can take up to 30 seconds while your
                                coverage portal initializes.
                            </p>
                        </div>
                    )}
                    {open && (
                        <iframe
                            data-testid="checkout-iframe"
                            src={checkoutUrl}
                            title="AdvantaShield checkout portal"
                            onLoad={() => setLoaded(true)}
                            className="h-full w-full border-0"
                            allow="payment"
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};
